<template>
  <div class="house-list">
    <ul>
      <li v-for="item in houseList" :key="item.id">
        <a @click="detailUrl(item.rentalType, item.propertyID, item.paymentStatus)">
          <div :class="['house-list-info', item.propertyStatus === 3 || item.propertyStatus === 0 ? 'sold' : '']">
            <div class="img-bottom">
              <div :class="['info-img', { starBorder: item.topType == 3 }]">
                <img v-lazy="pub.imgResize(item.imagePath)" onerror="errorImg(this)" />
                <!-- 超级置頂显示规则  topType == 1 && 未到期  -->
                <div class="star" v-if="item.topType == 3">{{ item.topTypeWithCulture }}</div>
                <span v-if="item.topType == 1 && !(item.expireTime <= parseInt(nowTime))" class="top">{{ item.topTypeWithCulture }}</span>
                <!-- 楼盘已验证标签 -->
                <!-- <span v-if="item.isVerifyLabel" class="bottom">{{ lang.isVerifyImg }}</span> -->
                <!-- 停售遮罩层 -->
                <div v-if="item.propertyStatus === 3 || item.propertyStatus === 0" class="soldBox">{{ item.propertyStatusWithCulture }}</div>
                <!-- 收藏 -->
                <span class="collection" v-if="collectList[item.propertyID]">
                  <div class="icon_xin"></div>
                </span>
                <!-- 图片总数 -->
              </div>
              <div class="imageNumber" v-if="item.imageNumber"><p>{{item.imageNumber}}</p></div>
              <!-- 业主盘平面图标签 -->
              <div :class="language === 'en-us' ? 'landlord_en' : 'landlord'" v-if="item.propertySource === 1">
                <p class="label_orange">
                  <img class="icon" src="@/assets/yezhupan.svg" />
                  <span>{{ lang.Landlord }}</span>
                </p>
              </div>
              <div :class="language === 'en-us' ? 'landlord_en' : 'landlord'" v-if="item.propertyLabel && item.propertyLabel[7]">
                <p class="label">
                  <img class="icon" src="@/assets/pingmiantu.svg" />
                  <span>{{ lang.plane }}</span>
                </p>
              </div>
            </div>
            <!-- 房源资料详细 -->
            <div class="info-detail">
              <!-- 标题 -->
              <div class="info-title">{{ item.titleWithCulture }}</div>
              <!-- 地区 -->
              <div class="info-cat">
                <span v-if="item.estateNameWithCulture || item.phaseWithCulture" class="span">{{ item.estateNameWithCulture }} {{ item.phaseWithCulture }}</span>
              </div>
              <div class="info-cat info-normal">
                <!--间隔+层数 -->
                <span v-if="item.roomNumberWithCulture">{{ item.roomNumberWithCulture }}&nbsp;</span>
                <span v-if="item.toiletNumberWithCulture">{{ item.toiletNumberWithCulture }}&nbsp;</span>
                <span v-if="item.unitFloorWithCulture">{{ item.toiletNumberWithCulture ? '|&nbsp;' + item.unitFloorWithCulture : item.unitFloorWithCulture }}</span>
              </div>
              <!-- 减价盘 -->
              <div class='reducePrice' v-if="item.isReducePaidSalePrice || item.isReduceRentPrice">
                <span v-if="item.subCategory && (item.subCategory[6] || item.subCategory[7])&& item.rentalType == 1" class="saleform">{{ lang.alPaid }} &nbsp;</span>
                <span class="decmid">{{ post.getPrice(item.rentalType === 1 ? item.firstPaidSalePrice : item.firstRentPrice, language).replace(/[^0-9|$|.]/gi, '')}}</span>
                <span class="decmid" v-if="
                    post
                      .getPrice(item.rentalType === 1 ? item.firstPaidSalePrice : item.firstRentPrice, language)
                      .substring(post.getPrice(item.rentalType === 1 ? item.firstPaidSalePrice : item.firstRentPrice, language).length - 1)
                      .search(/[\d]/gi) === -1"
                      >{{
                    post
                      .getPrice(item.rentalType === 1 ? item.firstPaidSalePrice : item.firstRentPrice, language)
                      .substring(post.getPrice(item.rentalType === 1 ? item.firstPaidSalePrice : item.firstRentPrice, language).length - 1)
                  }}
                </span>
                <span class="redRatio">&nbsp;{{item.rentalType === 1 ?item.reducePaidSalePriceRatio : item.reduceRentPriceRatio}}%</span>
              </div>
              <div class='reducePrice' v-if="item.isReduceUnPaidSalePrice">
                <span class="saleform">{{ lang.unPaid }} &nbsp;</span>
                <span class="decmid">{{ post.getPrice(item.firstUnPaidSalePrice, language).replace(/[^0-9|$|.]/gi, '') }}{{
                    post
                      .getPrice(item.firstUnPaidSalePrice, language)
                      .substring(post.getPrice(item.firstUnPaidSalePrice, language).length - 1)
                  }}
                </span>
                <span class="redRatio">&nbsp;{{item.reduceUnPaidSalePriceRatio}}%</span>
              </div>

              <!-- 价格部分 -->
              <div class="bh-price col-adress" v-if="item.paidSalePrice || item.rentPrice">
                <!--已補地價1未补，2已补，自由市場 綠表價/白居二  只展示固定类型楼盘-->
                <span v-if="item.subCategory && (item.subCategory[6] || item.subCategory[7])&& item.rentalType == 1" class="saleform">{{ lang.alPaid }} &nbsp;</span>
                <span class="card-price"> {{ post.getPrice(item.rentalType === 1 ? item.paidSalePrice : item.rentPrice, language).replace(/[^0-9|$|.]/gi, '') }} </span>
                <span
                  :class="language === 'en-us' ? 'card-price-small-en' : 'card-price-small'"
                  v-if="
                    post
                      .getPrice(item.rentalType === 1 ? item.paidSalePrice : item.rentPrice, language)
                      .substring(post.getPrice(item.rentalType === 1 ? item.paidSalePrice : item.rentPrice, language).length - 1)
                      .search(/[\d]/gi) === -1
                  "
                  >{{
                    post
                      .getPrice(item.rentalType === 1 ? item.paidSalePrice : item.rentPrice, language)
                      .substring(post.getPrice(item.rentalType === 1 ? item.paidSalePrice : item.rentPrice, language).length - 1)
                  }}</span
                >
                <div class="col-price">
                  <div class="practical col-adress">
                    <span class="practical-top">
                      {{ post.getAreaToText('', item.saleableArea, language, item.isVerifyArea) }}
                    </span>
                    <span class="practical-bottom" style="font-size: 11px">
                      {{ post.getAvgPriceToText('', item.saleableAvgPaidPrice, language) }}
                    </span>
                    <span v-if="item.saleableAvgPaidPrice && item.subCategory && (item.subCategory[6] || item.subCategory[7]) && item.rentalType == 1">{{lang.alPaid }}</span>

                  </div>
                  <div class="build col-adress" style="font-size: 11px">
                    <span class="build-top">
                      {{ post.getAreaToText(item.buildingArea, '', language, item.isVerifyArea) }}
                    </span>
                    <span class="build-bottom" style="font-size: 11px">
                      {{ post.getAvgPriceToText(item.buildingAvgPaidPrice, '', language) }}
                    </span>
                    <span v-if="item.buildingAvgPaidPrice && item.subCategory && (item.subCategory[6] || item.subCategory[7]) && item.rentalType == 1">{{lang.alPaid }}</span>

                  </div>
                </div>
              </div>

              <div class="bh-price col-adress" v-if="item.unPaidSalePrice && item.subCategory && (item.subCategory[6] || item.subCategory[7]) && item.rentalType == 1">
                <span v-if="item.subCategory && (item.subCategory[6] || item.subCategory[7]) && item.rentalType == 1" class="saleform"
                  >{{ lang.unPaid }} &nbsp;</span
                >
                <span class="card-price"> {{ post.getPrice(item.unPaidSalePrice, language).replace(/[^0-9|$|.]/gi, '') }} </span
                ><span
                  :class="language === 'en-us' ? 'card-price-small-en' : 'card-price-small'"
                  v-if="
                    post
                      .getPrice(item.unPaidSalePrice, language)
                      .substring(post.getPrice(item.unPaidSalePrice, language).length - 1)
                      .search(/[\d]/gi) === -1
                  "
                  >{{
                    post
                      .getPrice(item.unPaidSalePrice, language)
                      .substring(post.getPrice(item.unPaidSalePrice, language).length - 1)
                  }}</span
                >
                <div class="col-price">
                  <div class="practical col-adress">
                    <span v-if="!item.paidSalePrice" class="practical-top">
                      {{ post.getAreaToText('', item.saleableArea, language, item.isVerifyArea) }}
                    </span>
                    <span class="practical-bottom" style="font-size: 11px">
                      {{ post.getAvgPriceToText('', item.saleableAvgUnPaidPrice, language) }}
                    </span>
                    <span v-if="item.saleableAvgUnPaidPrice">{{lang.unPaid }}</span>

                  </div>
                  <div class="build col-adress" style="font-size: 11px">
                    <span class="build-top" v-if="!item.paidSalePrice">
                      {{ post.getAreaToText(item.buildingArea, '', language, item.isVerifyArea) }}
                    </span>
                    <span class="build-bottom" style="font-size: 11px">
                      {{ post.getAvgPriceToText(item.buildingAvgUnPaidPrice, '', language) }}
                    </span>
                    <span v-if="item.buildingAvgUnPaidPrice">{{lang.unPaid }}</span>
                  </div>
                </div>
              </div>

              <!-- 标签 -->
              <div class="bottom">
                <!-- <p class="bh-company col-adress">{{getCompany(item.companyNameWithCulture,item.propertySource)}}</p> -->
                <!-- <p class="col-remark col-adress" v-if="item.remark">{{ lang.collectionNotes }}：{{ item.remark }}</p>
                <p v-else class="col-remark col-adress"></p> -->
                <div class="info-property-tags">
                  <!-- 住宅 单栋式大厦 -->
                  <template v-if="item.propertyCategoryWithCulture">
                    <span class="tags-span property col-adress"
                      >{{ item.propertyCategoryWithCulture }}
                      <span v-for="(it, index) in item.subCategoryInfos" :key="index"> {{ it.name }}<span v-if="index !== item.subCategoryInfos.length - 1"> | </span></span>
                    </span>
                  </template>
                  <template v-if="item.rentLabel">
                    <span class="tags-span property col-adress" v-show="index == 3 || index == 4 || index == 5 || index == 8" v-for="(it, index) in item.rentLabel" :key="index + 10"
                      ><p v-if="index == 3 || index == 4 || index == 5 || index == 8">{{ it }}</p></span
                    >
                  </template>
                  <!-- 不显示代理盘，只显示业主盘 -->
                  <!-- <template>
                    <span
                      class="tags-span property col-adress"
                      v-if="
                        (item.propertySourceWithCulture && item.propertySourceWithCulture == '業主盤') || item.propertySourceWithCulture == 'Landlord' || item.propertySourceWithCulture == '业主盘'
                      "
                      >{{ item.propertySourceWithCulture }}</span
                    >
                  </template> -->
                  <!-- <div v-if="item.featureDictionary">
                  <span class="tags-span" v-for="(it, i) in item.featureDictionary" :key="i">{{ it }}</span>
                </div> -->
                  <template v-if="item.propertyTag && item.propertyTag.length > 0">
                    <span v-for="(it, i) in item.propertyTag" :key="i">
                      <span class="tags-span col-adress" v-if="i < 5">{{ it.propertyTagName }}</span>
                    </span>
                  </template>
                </div>
              </div>

              <!-- 代理公司 -->
              <!-- <div class="info-company"> -->
              <!-- 公司图标 -->
              <!-- <span class="img">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-dailigongsi" />
                  </svg>
                </span>-->
              <!-- 公司名称 -->
              <!-- {{ getCompany(item.companyNameWithCulture, item.propertySource) }}
              </div> -->
            </div>
          </div>
          <!-- <div v-if="collectList[item.propertyID]" class="notice">{{ lang.beizhu }}{{ collectList[item.propertyID] }}</div> -->
          <div class="sale_info" @click.stop="goDetail(item)">
            <div class="info">
              <!-- House730樓盤編號： -->
              <p>
                {{ lang.PropertyID }}：<span>{{ item.propertyID }}</span>
                <span class="xjStatus" v-if="item.isAdminOffLine">{{ lang.OffLine }}</span>
              </p>
              <!-- 付款方式 -->
              <p>
                {{ lang.paymentMethod }}：<span>{{ item.paymentPlan === 1 ? lang.paid : item.paymentPlan === 2 ? lang.free : '' }}</span>
              </p>
              <!-- 放盘日期 -->
              <p v-if="item.paymentStatus">
                {{ lang.Redata }}：<span>{{ item.publicTime | getTime }}</span>
              </p>
              <p>
                <!-- 放盘状态 -->
                {{ lang.Status }}：
                <!-- 审核状态 -->
                <span class="value" v-if="item.paymentStatus == 0">{{ lang.status.wait }}</span>
                <span class="value" v-else-if="item.isAdminOffLine == true">{{ lang.status.Obtained }}</span>
                <span class="value" v-else-if="item.paymentStatus == 1 && item.approvalStatus == 0">{{ lang.status.passing }}</span>
                <span class="value" v-else-if="item.paymentStatus == 1 && item.approvalStatus == 1">{{ lang.status.passed }}</span>
                <span class="value" v-else-if="item.paymentStatus == 1 && item.approvalStatus == -1">{{ lang.status.nopass }}</span>
              </p>
              <!-- 放盘到期 如果未支付不展示 -- -->
              <p v-if="item.paymentStatus == 1">
                {{ lang.exday }}：
                <span v-if="item.expireTime > 0">
                  {{ item.expireTime | getTime }}
                  <span v-if="item.expireTime <= parseInt(nowTime)">({{ lang.exdayed }})</span>
                </span>
                <span v-else>-</span>
              </p>
              <!-- 重新置顶数次 -- -->
              <p>
                {{ lang.Pushable }}： <span>{{ item.topType == 0 ? '0' : item.recommendNumber }}</span>
              </p>
              <!-- 浏览人数 -->
              <p>
                {{ lang.visitorsNum }}：<span>{{ item.browseNumber }}</span>
              </p>
              <!-- 留言数目 -->
              <p>
                {{ lang.messageNum }}：<span>{{ item.leaveMessageNumber }}</span>
              </p>
              <!-- 预设页面 >0展示-->
              <p v-if="item.topType == 3 && item.globalRank > 0">
                {{ lang.defaultPage }}：<span v-if="language == 'en-us'">{{ lang.Page }}{{ item.globalRankPage }}</span>
                <span v-else>{{ item.globalRankPage }}{{ lang.Page }}</span>
                <span v-if="language == 'en-us'">,{{ lang.Position }}{{ item.globalRank }}</span>
                <span v-else>,{{ lang.di }}{{ item.globalRank }}{{ lang.Position }}</span>
              </p>
              <!-- 18區頁面 -->
              <p v-if="item.topType == 3 && item.zoneRank > 0">
                {{ lang.DistrictPage }}：<span v-if="language == 'en-us'">{{ lang.Page }}{{ item.zoneRankPage }}</span>
                <span v-else>{{ item.zoneRankPage }}{{ lang.Page }}</span>
                <span v-if="language == 'en-us'">,{{ lang.Position }}{{ item.zoneRank }}</span>
                <span v-else>,{{ lang.di }}{{ item.zoneRank }}{{ lang.Position }}</span>
              </p>
            </div>
            <div class="edit">{{ lang.edit }}</div>
          </div>
        </a>
      </li>
    </ul>
    <van-dialog v-model="show" @confirm="goBack" :confirm-button-text="lang.confirmBtn">
      <div class="text" v-html="lang.stopText"></div>
    </van-dialog>
  </div>
</template>

<script>
import lang from './../../common/language/editProperty';
import post from './../../common/js/post';
const _conf = require('../../common/js/_conf');
export default {
  data() {
    return {
      post,
      url: document.URL,
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
      lang,
      collectList: {},
      nowTime: new Date().getTime() / 1000,
      query: '',
      app: '',
      version: '',
      show: false,
    };
  },
  filters: {
    avgPrice(val) {
      return Math.round(val);
    },
    /** 遍历出 房源小分类 */
    subCategory(val) {
      const arr = Object.keys(val);
      const valArr = arr.map(function (i) {
        return val[i];
      });
      let valStr = '';
      valArr.forEach((item) => {
        valStr += ' ' + item;
      });
      return valStr;
    },
  },
  props: {
    houseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      default: 'sale',
    },
    isDisable: {
      default: true,
    }
  },
  created() {
    this.app = this.$route.query.fromapp ? `?fromapp=${this.$route.query.fromapp}` : '';
    this.version = this.$route.query.version ? `&version=${this.$route.query.version}` : '';
    this.loadCollectAll(1);
    post.getQuery(this);
  },
  watch: {
    type(nwal) {
      this.loadCollectAll(1);
    },
  },
  methods: {
    /** 获取代理公司 */
    getCompany(company, property, language) {
      if (!company && property === 1) {
        return this.lang.landlord;
      } else if (!company && property === 2) {
        return this.lang.agency;
      } else if (company) {
        return company;
      }
    },
    /** 获取全部的收藏数据 */
    loadCollectAll(index) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
          sourceType: this.type,
          pageCount: 100,
          pageIndex: index,
          isShowSourceInfo: true,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.result.data.forEach((item) => {
              // this.collectList[item.sourceID] = item.remark
              this.$set(this.collectList, item.sourceID, item.remark);
            });
            if (res.data.result.count > index * 100) {
              this.loadCollectAll(index + 1);
            }
          }
        });
    },
    /** 跳转到详情页 */
    detailUrl(rentalType, id, paystatus) {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      let type = '';
      if (rentalType == 1) {
        type = 'buy';
      } else if (rentalType == 2) {
        type = 'rent';
      }
      if (document.URL.indexOf('en-us') > -1) {
        location.href = `${base}/en-us/${type}-property-${id}${this.app}`;
      } else if (document.URL.indexOf('zh-cn') > -1) {
        location.href = `${base}/zh-cn/${type}-property-${id}${this.app}`;
      } else {
        location.href = `${base}/${type}-property-${id}${this.app}`;
      }

      // if (paystatus == 0) {
      //   // const userToken = this.pub.getCookie('cEVaUDFrZ1kd0RA');
      // }
      // else {
      //   location.href = `/${type}-property-${id}.html`;
      // }
    },
    rentLabel(val) {
      if (val[3] && val[4]) {
        return `${this.lang.shortRent} ${this.lang.shareRent}`; // 短租 / 分租
      } else if (val[3]) {
        return this.lang.shortRent;
      } else if (val[4]) {
        return this.lang.shareRent;
      }
    },
    goBack() {
      let app = this.$route.query.fromapp
      if (app) {
        const ua = navigator.userAgent.toLowerCase();
        let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端
        try {
          if (isAndroid) {
            window.house730.closePage();
          } else {
            window.webkit.messageHandlers.closePage.postMessage(JSON.stringify({}));
          }
        } catch (error) {}
      } else {
        this.$router.push('/');
      }
    },
    goDetail(item) {
      if (this.isDisable === false) {
        this.show = true;
      } else {
        this.$router.push(`/editProDetail/${item.propertyID}/${this.app}${this.version}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.van-dialog {
  border-radius: 10px;
  .van-dialog__content {
    .text {
      padding: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
}
.opacity {
  opacity: 0.55;
}
.icon_heart {
  font-size: 20px;
}
.house-list {
  .col-adress {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .reducePrice{
    margin:4px 0;
    .saleform{
     font-size:10px;
     color: #999999
    }
    .decmid{
      text-decoration:line-through;
      color: #999999;
      font-weight: 600;
      font-size:12px;
    }
    .redRatio{
      font-size:12px;
      color:#333333;
      font-weight: 600;
    }
  }
  .bh-price {
    display: flex;
    align-items: center;
    padding-right: 15px;
    padding-bottom: 9px;
    .saleform {
      font-size: 10px;
      color: #333;
    }
    .card-price {
      font-size: 20px;
      color: #ed1c24;
      font-weight: bold;
    }
    .card-price-small {
      margin-top: 2px;
      font-size: 14px;
      color: #ed1c24;
    }
    .card-price-small-en {
      margin-top: 5px;
      font-size: 14px;
      color: #ed1c24;
    }
    .col-price {
      display: flex;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-direction: row;
      align-items: flex-start;
      .practical {
        padding-left: 4px;
        font-size: 11px;
        color: #999999;
        max-width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .practical-top{
        font-size: 11px;
        color:#333333;
      }
      .practical span {
        line-height: 14px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .build span {
        line-height: 14px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .build {
        padding-left: 4px;
        font-size: 11px;
        color: #999999;
        max-width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .build-top{
          font-size:11px;
          color:#333333;
        }
      }
    }
  }
  // 标签部分
  .bottom {
    .col-remark {
      display: inline-block;
      margin-top: 2px;
      height: 18px;
      font-size: 12px;
      color: #999999;
      min-width: 120px;
      margin-right: 16px;
    }
    .info-property-tags {
      max-height: 100px;
      padding-right: 15px;
      text-align: left;
      display: inline-block;
      overflow: hidden;
      .tags-span {
        color: #617e9d;
        margin: 0px 4px 4px 0;
        padding: 0 4px;
        font-size: 12px;
        line-height: 16px;
        display: inline-block;
        background-color: #eef8ff;
        max-width: 200px;
        font-family: PingFangSC-Regular;
      }
      .property {
        color: #536ea6;
        background-color: #dfe9ff;
      }
    }
  }
  .notice {
    color: #999;
    font-size: 10px;
    height: 16px;
    position: relative;
    // top: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 16px;
  }
  ul {
    .soldBox {
      background-color: #292630;
      opacity: 0.55;
      height: 90px;
      text-align: center;
      line-height: 90px;
      width: 120px;
      font-size: 17px;
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
    }
    .sold {
      opacity: 0.55;
    }
    padding-left: 15px;
    // padding-right: 15px;
    li a {
      position: relative;
      overflow: hidden;
      padding: 16px 0;
      display: block;
      border-bottom: 1px solid #eee;
      .house-list-info {
        position: relative;
        display: flex;
        .starBorder {
          border: 3px solid #ff2119 !important;
        }
        .img-bottom {
          margin-bottom: 8px;
        }
        .info-img {
          background: url('//static.house730.com/m/images/house-bg.png');
          display: block;
          width: 120px;
          height: 90px;
          background-size: cover;
          position: relative;
          img {
            background: #fff;
          }

          .star {
            position: absolute;
            left: 5px;
            top: 5px;
            height: 16px;
            padding: 1px 3px;
            color: #fff;
            text-align: center;
            background-color: #ff2119;
            border-radius: 2px;
            display: flex;
            -webkit-transform: scale(0.9);
            font-size: 10px;
            font-family: PingFangSC-Medium;
            line-height: 16px;
          }
          .top {
            position: absolute;
            top: 0;
            padding: 0 8px;
            height: 17px;
            background-color: #f4a100;
            font-size: 10px;
            color: #fff;
            text-align: center;
            line-height: 17px;
            border-radius: 0 0 8px 0;
          }
          .bottom {
            position: absolute;
            bottom: 0;
            padding: 0 8px;
            height: 17px;
            background-color: #0054a6;
            font-size: 10px;
            color: #fff;
            text-align: center;
            line-height: 17px;
          }
          .collection {
            position: absolute;
            top: 2px;
            right: 4px;
            .icon_xin {
              height: 18px;
              width: 18px;
              background-image: url('//static.house730.com/m/images/soucang.png');
              background-size: 18px 18px;
            }
            i {
              color: #fff;
            }
          }
          img {
            // background-image: url('//static.house730.com/m/images/house-bg.png');
            background-size: 120px 90px;
            display: block;
            height: 90px;
            width: 120px;
          }
        }
        .imageNumber {
          position: absolute;
          left: 88px;
          top: 68px;
          width: 28px;
          height: 18px;
          // background-color: black;
          background-color: rgba(0, 0, 0, 0.5);
          font-size: 12px;
          color: #fff;
          text-align: center;
          border-radius: 2px;
          line-height: 18px;
          z-index: 50;
        }
        .imageNumber p {
          z-index: 51;
        }
        .landlord {
          margin-top: 8px;
          img {
            display: inline-block;
            width: 14px;
            height: 14px;
            background-color: rgba(255, 255, 255, 0.1);
          }
          .label {
            width: 60px;
            height: 18px;
            color: #056de0;
            padding: 0px 3px;
            font-size: 12px;
            border-radius: 2px;
            background-color: #e3f0ff;
            box-shadow: 0 0 0 1px #056de0;
            box-sizing: border-box;
            line-height: 18px;
            display: flex;
            align-items: center;
            margin-left: 1px;
            span {
              margin-left: 2px;
              transform: scale(0.95);
              transform-origin: 50% 100%;
            }
          }
          .label_orange {
            width: 60px;
            height: 18px;
            color: #ed1c24;
            padding: 0px 3px;
            font-size: 12px;
            border-radius: 2px;
            background-color: #ffe3e3;
            box-shadow: 0 0 0 1px #ed1c24;
            box-sizing: border-box;
            line-height: 18px;
            display: flex;
            align-items: center;
            margin-left: 1px;
            span {
              margin-left: 2px;
              transform: scale(0.95);
              transform-origin: 50% 100%;
            }
          }
        }
        .landlord_en {
          margin-top: 8px;
          img {
            display: inline-block;
            width: 14px;
            height: 14px;
            background-color: rgba(255, 255, 255, 0.1);
          }
          .label {
            width: 80px;
            height: 18px;
            color: #056de0;
            padding: 0px 3px;
            font-size: 12px;
            border-radius: 2px;
            background-color: #e3f0ff;
            box-shadow: 0 0 0 1px #056de0;
            box-sizing: border-box;
            line-height: 18px;
            display: flex;
            align-items: center;
            margin-left: 1px;
            span {
              margin-left: 2px;
              transform: scale(0.95);
              transform-origin: 50% 100%;
            }
          }
          .label_orange {
            width: 80px;
            height: 18px;
            color: #ed1c24;
            padding: 0px 3px;
            font-size: 12px;
            border-radius: 2px;
            background-color: #ffe3e3;
            box-shadow: 0 0 0 1px #ed1c24;
            box-sizing: border-box;
            line-height: 18px;
            display: flex;
            align-items: center;
            margin-left: 1px;
            span {
              margin-left: 2px;
              transform: scale(0.95);
              transform-origin: 50% 100%;
            }
          }
        }
        .info-detail {
          width: calc(100% - 145px);
          display: block;
          // height: 90px;
          padding-left: 16px;
          font-size: 10px;
          color: #666;
          .info-title {
            color: #333;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /*! autoprefixer: ignore next */
            -webkit-box-orient: vertical;
            font-size: 17px;
            font-weight: 700;
            line-height: 23px;
            height: 46px;
            overflow: hidden;
          }
          .info-size {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 14px;
            margin: 4px 0;
          }
          .info-cat {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            line-height: 17px;
            .span {
              color: #4d73bf;
            }
          }
          .info-normal {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
          .info-price {
            width: 200px;
            display: flex;
            color: #999;
            .price {
              color: #ed1c24;
              font-size: 20px;
              font-weight: 700;
              line-height: 28px;
            }
            .area {
              padding-left: 6px;
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
                font-size: 10px;
                line-height: 14px;
              }
            }
          }
          .info-company {
            margin: 8px 0px 8px 0px;
            line-height: 26px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-top: 1px solid #eeeeee;
            .img {
              font-size: 22px;
              position: relative;
              top: 4px;
            }
            font-size: 11px;
            // line-height: 16px;
            color: #333;
          }
        }
      }
      .notice-right {
        clip-path: polygon(50% 0%, 100% 100%, 100% 100%, 0% 100%);
        height: 25px;
        width: 50px;
        position: absolute;
        transform: rotate(45deg);
        top: 9px;
        right: -8px;
        transform-origin: bottom center;
        font-size: 10px;
        line-height: 32px;
        color: #fff;
        text-align: center;
        background-color: #2d73ff;
      }
    }
  }
  .sale_info {
    width: 90%;
    background-color: #f5f6f7;
    // margin-top: 15px;
    padding: 16px 8px 16px 8px;
    display: flex;
    justify-content: space-between;
    .xjStatus {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #666666;
      margin-left: 4px;
      background-color: #e5e5e5;
      padding: 2px 4px;
    }
    .edit {
      font-size: 12px;
      color: #0076ff;
      background-color: #f5f6f7;
      height: 20px;
      min-width: 40px;
      z-index: 999;
    }
    p {
      font-size: 10px;
      color: #999999;
      line-height: 14px;
      span {
        color: #2a2a2a;
      }
    }
  }
  .oneline {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
